import { scrollToTop } from "helpers/scroll-helpers";
import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SupportStickyBar from "components/support/SupportStickyBar";
import SelfCampaignBrandHeader from "./SelfCampaignBrandHeader";
import "./SelfCampaignPageLayout.scss";

type SelfCampaignPageLayoutVariant = "create" | "design" | "activate";

type SelfCampaignPageLayoutProps = {
  children: ReactNode;
  footer?: ReactNode;
  rootClassName?: string;
  variant: SelfCampaignPageLayoutVariant;
};

const SelfCampaignPageLayout: React.FC<SelfCampaignPageLayoutProps> = ({
  children,
  footer,
  rootClassName,
  variant,
}) => {
  const location = useLocation();

  useEffect(() => {
    scrollToTop();
  }, [location.pathname, location.search]);

  const rootClasses = ["self-campaign-page-layout", rootClassName]
    .filter(Boolean)
    .join(" ");

  const mainClasses = [
    "self-campaign-page-layout__main",
    `self-campaign-page-layout__main--${variant}`,
  ].join(" ");

  return (
    <div className={rootClasses}>
      <SupportStickyBar height={42} visibility="always" />
      <SelfCampaignBrandHeader />
      <main className={mainClasses}>{children}</main>
      {footer}
    </div>
  );
};

export default SelfCampaignPageLayout;
